import R from 'ramda'
import { buildGoogleSheetUrl } from '../../../common-functions'

const GOOGLE_SHEET_APPEND_ACTION_TYPE = 'GOOGLE_SHEET_APPEND'
const GOOGLE_SHEET_APPEND_DISPLAY_TYPE = 'Google Sheet Append'

const isGoogleSheetAppendWidgetAction = R.propEq(
  'type',
  GOOGLE_SHEET_APPEND_ACTION_TYPE
)

const convertGoogleSheetAppendWidgetActionToFormAction = R.applySpec({
  type: R.always(GOOGLE_SHEET_APPEND_DISPLAY_TYPE),
  sheetUrl: buildGoogleSheetUrl,
  row: R.prop('row')
})

export {
  isGoogleSheetAppendWidgetAction,
  convertGoogleSheetAppendWidgetActionToFormAction
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/common/widget-to-form/google-sheet-append.js